let prodURL="https://checkout.foree.co";
let snadboxURL="https://checkout-sandbox.riteidentity.com";
let isTestMode =false;
let initiateCheckoutInterval;

function initiateCheckout(obj,boolean){
  isTestMode = boolean;
  let URL=getForeeCheckoutURL();
  var cjs = document.createElement("script");
  cjs.type = "text/javascript";
  cjs.src = URL+'/checkout.js';
  document.head.appendChild(cjs);
  setTimeout(() => {
    initiateCheckoutInterval = setInterval(() => { executeCheckoutFunction(obj); }, 1000);
  }, 1000);
}

function executeCheckoutFunction(obj) {
  if (typeof getScriptUrl === "function") {
    clearInterval(initiateCheckoutInterval);
    initiateForeeCheckout(obj);
  }
}

function getForeeCheckoutURL(){
  if(isTestMode){
    return snadboxURL;
  }
  return prodURL;
};
module.exports={
  initiateCheckout:initiateCheckout,
  getForeeCheckoutURL:getForeeCheckoutURL
}